import { FrequentlyShippedProductsAction } from './actions';
import { FrequentlyShippedProductsActionTypes, FrequentlyShippedProductsState } from './types';

const initialState: FrequentlyShippedProductsState = {
  frequentlyShippedProducts: [],
  isLoading: false,
  error: null,
  lastFetched: null,
};

const CACHE_DURATION = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

export const storeReducer = (
  state = initialState,
  action: FrequentlyShippedProductsAction
): FrequentlyShippedProductsState => {
  switch (action.type) {
    case FrequentlyShippedProductsActionTypes.FETCH_PRODUCTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case FrequentlyShippedProductsActionTypes.FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        frequentlyShippedProducts: action.payload,
        isLoading: false,
        error: null,
        lastFetched: Date.now(),
      };

    case FrequentlyShippedProductsActionTypes.FETCH_PRODUCTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

// Helper function to check if we need to fetch data
export const shouldFetchProducts = (state: FrequentlyShippedProductsState, isGAPConnected: boolean): boolean => {
  if (!isGAPConnected) return false;
  if (state.isLoading) return false;
  if (state.frequentlyShippedProducts.length === 0) return true;
  if (!state.lastFetched) return true;

  const now = Date.now();
  return now - state.lastFetched > CACHE_DURATION;
};
